module.exports = "pegasus/assets/themelp1/health/100.png";